import type { ReactNode } from 'react';

/** Ikony z prototypu (stroke 1.8, viewBox 24). */
function Ic({ children, className = 'i' }: { children: ReactNode; className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const I = {
  home: (
    <Ic>
      <path d="M3 11.5 12 4l9 7.5" />
      <path d="M5.5 10.5V20h13v-9.5" />
    </Ic>
  ),
  docs: (
    <Ic>
      <path d="M7 3h7l5 5v13H7z" />
      <path d="M14 3v5h5" />
      <path d="M10 13h5M10 17h5" />
    </Ic>
  ),
  plus: (
    <Ic>
      <path d="M12 5v14M5 12h14" strokeWidth="2.4" />
    </Ic>
  ),
  pay: (
    <Ic>
      <rect x="3" y="6" width="18" height="13" rx="2.5" />
      <path d="M3 10.5h18" />
      <circle cx="16.5" cy="15" r="1.2" fill="currentColor" stroke="none" />
    </Ic>
  ),
  more: (
    <Ic>
      <circle cx="5" cy="12" r="1.7" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.7" fill="currentColor" stroke="none" />
      <circle cx="19" cy="12" r="1.7" fill="currentColor" stroke="none" />
    </Ic>
  ),
  back: (
    <Ic>
      <path d="M15 5l-7 7 7 7" />
    </Ic>
  ),
  chev: (
    <Ic>
      <path d="M9 5l7 7-7 7" />
    </Ic>
  ),
  search: (
    <Ic>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m20 20-4.5-4.5" />
    </Ic>
  ),
  transfer: (
    <Ic>
      <path d="M3 21h18M5 21V10M9 21V10M15 21V10M19 21V10M2 10 12 4l10 6z" />
    </Ic>
  ),
  cash: (
    <Ic>
      <rect x="2" y="7" width="20" height="10" rx="2" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M6 12h.01M18 12h.01" />
    </Ic>
  ),
  card: (
    <Ic>
      <rect x="2" y="5" width="20" height="14" rx="2.5" />
      <path d="M2 10h20M6 15h4" />
    </Ic>
  ),
  offset: (
    <Ic>
      <path d="M4 7h13l-3-3M20 17H7l3 3" />
    </Ic>
  ),
  box: (
    <Ic>
      <path d="M3 8.5 12 4l9 4.5v7L12 20l-9-4.5z" />
      <path d="M3 8.5 12 13l9-4.5M12 13v7" />
    </Ic>
  ),
  people: (
    <Ic>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
      <path d="M16 4.5a3.5 3.5 0 0 1 0 7" />
      <path d="M17.5 13.5a6 6 0 0 1 4 6.5" />
    </Ic>
  ),
  building: (
    <Ic>
      <path d="M4 21V5l8-2.5L20 5v16" />
      <path d="M9 21v-4h6v4" />
      <path d="M8 9h2M14 9h2M8 13h2M14 13h2" />
    </Ic>
  ),
  chart: (
    <svg
      className="i"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M4 20V10" />
      <path d="M10 20V4" />
      <path d="M16 20v-7" />
      <path d="M22 20H2" />
    </svg>
  ),
  hash: (
    <Ic>
      <path d="M5 9h14M5 15h14M10 3 8 21M16 3l-2 18" />
    </Ic>
  ),
  bell: (
    <Ic>
      <path d="M6 16V11a6 6 0 0 1 12 0v5l2 2H4l2-2Z" />
      <path d="M10 20a2 2 0 0 0 4 0" />
    </Ic>
  ),
  /** analytika webů – zeměkoule */
  globe: (
    <Ic>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3z" />
    </Ic>
  ),
  /** zakázky a opravy – klíč */
  wrench: (
    <Ic>
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.8-3.8a6 6 0 0 1-7.9 7.9l-6.9 6.9a2.1 2.1 0 0 1-3-3l6.9-6.9a6 6 0 0 1 7.9-7.9z" />
    </Ic>
  ),
  /** návody – otazník v kruhu */
  help: (
    <Ic>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9.2a2.6 2.6 0 0 1 5 .9c0 1.7-2.5 2.2-2.5 3.9" />
      <path d="M12 17.2h.01" />
    </Ic>
  ),
  export: (
    <Ic>
      <path d="M12 3v12" />
      <path d="m7 10 5 5 5-5" />
      <path d="M4 19h16" />
    </Ic>
  ),
  /** AI asistent */
  sparkle: (
    <Ic>
      <path d="M12 3.5 13.9 9l5.6 1.9-5.6 1.9L12 18.3l-1.9-5.5-5.6-1.9L10.1 9z" />
      <path d="M19 3v3M17.5 4.5h3" />
    </Ic>
  ),
  calendar: (
    <Ic>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
      <path d="M3.5 10h17M8 3v4M16 3v4" />
    </Ic>
  ),
  /** úkoly mozku (opakovaná práce) */
  repeat: (
    <Ic>
      <path d="M4 12a8 8 0 0 1 13.7-5.6L20 8.5" />
      <path d="M20 4v4.5h-4.5" />
      <path d="M20 12a8 8 0 0 1-13.7 5.6L4 15.5" />
      <path d="M4 20v-4.5h4.5" />
      <path d="M12 8.5V12l2.5 1.5" />
    </Ic>
  ),
  /** reklamy */
  megaphone: (
    <Ic>
      <path d="M4 10v4a1 1 0 0 0 1 1h2l5 4V5L7 9H5a1 1 0 0 0-1 1z" />
      <path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" />
    </Ic>
  ),
  send: (
    <Ic>
      <path d="M12 19V5" strokeWidth="2.2" />
      <path d="m6 11 6-6 6 6" strokeWidth="2.2" />
    </Ic>
  ),
  camera: (
    <Ic>
      <path d="M4 8.5h3l1.6-2.5h6.8L17 8.5h3V19H4z" />
      <circle cx="12" cy="13.3" r="3.3" />
    </Ic>
  ),
  mic: (
    <Ic>
      <rect x="9" y="3.5" width="6" height="11" rx="3" />
      <path d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v2.5" />
    </Ic>
  ),
  history: (
    <Ic>
      <path d="M4 12a8 8 0 1 0 2.4-5.7" />
      <path d="M4 4v4h4M12 8v4l3 2" />
    </Ic>
  ),
};
